<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Mon compte
                <span>Gérez mes informations personnelles</span>
            </h1>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="row">
            <div class="colWidget col-lg-6">
                <div class="row">
                    <div class="col-12">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Mes informations de facturation</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="accountForm">
                                    <div class="card-text row">
                                        <div class="col-lg-12">
                                            <mat-form-field>
                                                <mat-label>Email</mat-label>
                                                <input matInput formControlName="email" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('email').invalid">{{ formService.getErrorMessage(accountForm.get('email')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Prénom</mat-label>
                                                <input matInput formControlName="firstName"
                                                       class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('firstName').invalid">{{ formService.getErrorMessage(accountForm.get('firstName')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nom</mat-label>
                                                <input matInput formControlName="lastName" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('lastName').invalid">{{ formService.getErrorMessage(accountForm.get('lastName')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Société (facultatif)</mat-label>
                                                <input matInput formControlName="company_name"
                                                       class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('company_name').invalid">{{ formService.getErrorMessage(accountForm.get('company_name')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Mobile</mat-label>
                                                <input matInput formControlName="mobile" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('mobile').invalid">{{ formService.getErrorMessage(accountForm.get('mobile')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-12">
                                            <mat-form-field class="lines-2">
                                                <mat-label>Adresse</mat-label>
                                                <textarea formControlName="adress"
                                                          matInput
                                                          placeholder=""></textarea>
                                                <mat-error
                                                    *ngIf="accountForm.get('adress').invalid">{{ formService.getErrorMessage(accountForm.get('adress')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Code postal</mat-label>
                                                <input formControlName="zip_code" matInput class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('zip_code').invalid">{{ formService.getErrorMessage(accountForm.get('zip_code')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Ville</mat-label>
                                                <input formControlName="city" matInput class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('city').invalid">{{ formService.getErrorMessage(accountForm.get('city')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-lg-12">
                                            <mat-checkbox formControlName="mailing">
                                                Je souhaite être informé par mail des nouveautés et des
                                                conseils LyBox
                                            </mat-checkbox>
                                            <br/>
                                            <br/>
                                        </div>

                                    </div>
                                </form>
                                <div class="mb-3" id="wonderpush-subscription-switch"
                                     data-color-on="#0075DB"
                                     data-sentence="Activer les notifications sur cet appareil : "></div>
<!--                                <a href="#" onclick="WonderPush.subscribeToNotifications(event); return false;">Activer les notifications</a>-->
<!--                                <a href="#" onclick="console.log(WonderPush.showSubscriptionDialog()); return false;">Activer les notifications</a>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Mot de passe</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="passwordForm" (ngSubmit)="passwordUpdate()">
                                    <div class="card-text row">
                                        <div class="col-12">
                                            <mat-form-field>
                                                <mat-label>Mot de passe actuel</mat-label>
                                                <input matInput formControlName="old_password"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('old_password').invalid">{{ formService.getErrorMessage(passwordForm.get('old_password')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nouveau mot de passe</mat-label>
                                                <input matInput formControlName="new_password"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('new_password').invalid">{{ formService.getErrorMessage(passwordForm.get('new_password')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nouveau mot de passe</mat-label>
                                                <input matInput formControlName="new_password2"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('new_password2').invalid">{{ formService.getErrorMessage(passwordForm.get('new_password2')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary"
                                                    [disabled]="passwordForm.invalid">
                                                Enregistrer
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="user.pro_plan == ''">
                        <div class="card block isMinimizable minimize">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Suppression de compte</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <p>
                                    Vous pouvez supprimer votre compte LyBox à tout moment. Cette action est
                                    irréversible et entrainera la perte de toutes vos données présente sur LyBox
                                    (favoris, recherches, simulations ...)
                                </p>
                                <p class="text-center">
                                    <a routerLink="/app/user/plan" class="fs-4" *ngIf="user.plan != '' && user.plan != 'trial' && (user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970')">
                                        Cliquez ici pour resiliter votre abonnement avant de pouvoir supprimer votre compte.
                                    </a>
                                    <button *ngIf="(user.plan == '' && user.subscription.cancel_date != '01/01/0001' && user.subscription.cancel_date != '01/01/1970') || user.plan == 'trial' || user.plan == ''" type="button" (click)="deleteAccount()" class="btn btn-danger float-none">
                                        Supprimer mon compte
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="colWidget col-lg-6">
                <div class="row">
                    <div class="col-12" *ngIf="user.pro_plan == ''">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2 *ngIf="!authenticationService.isInfluenceur(user)">
                                        Parrainage
                                    </h2>
                                    <h2 *ngIf="authenticationService.isInfluenceur(user)">
                                        Affiliation
                                    </h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="accountForm">
                                    <div class="card-text row">
                                        <div class="col-12">
                                            <h3 class="mb-3"
                                                *ngIf="!authenticationService.isInfluenceur(user)">
                                                Mes filleuls
                                            </h3>
                                            <h3 class="mb-3"
                                                *ngIf="authenticationService.isInfluenceur(user)">
                                                Mes affiliés
                                            </h3>

                                            <div class="infoCb mb-4" *ngIf="!authenticationService.isInfluenceur(user)">
                                                Partagez LyBox avec vos amis offrez leur un mois d'abonnement et recevez
                                                vous aussi un
                                                mois gratuit.<br/>
                                                Pour cela, envoyez votre lien ou votre code de parrainage à votre
                                                filleul pour qu’il
                                                s’inscrive à LyBox : <br/><br/>
                                                Code d'affiliation : <b>{{ user.code_filleul }}</b> ou partager votre
                                                lien :
                                                <a href="https://www.lybox.fr/app/register?parrain={{ user.code_filleul }}">https://www.lybox.fr/app/register?parrain={{ user.code_filleul }}</a>
                                            </div>

                                            <div class="infoCb mb-4" *ngIf="authenticationService.isInfluenceur(user)">
                                                Partager votre lien :
                                                <a href="https://www.lybox.fr/app/partner/{{ user.code_filleul | lowercase }}">
                                                    https://www.lybox.fr/app/partner/{{ user.code_filleul | lowercase }}
                                                </a> / <a
                                                href="https://www.lybox.fr/app/search/result?partner={{ user.code_filleul | lowercase }}">https://www.lybox.fr/app/search/result?partner={{ user.code_filleul | lowercase }}</a>
                                                ou votre code d'affiliation : <b>{{ user.code_filleul }}</b><br/>
                                                <br/>
                                                <ng-container *ngIf="authenticationService.getInfluenceurRevenue(user).discount > 0">
                                                Tous vos affiliés bénéficient de l'offre :
                                                "{{ authenticationService.getInfluenceurRevenue(user).discount }}%
                                                de
                                                reduction {{ authenticationService.getInfluenceurRevenue(user).condition }}
                                                sur tous les abonnements LyBox" et
                                                </ng-container>
                                                {{ authenticationService.getInfluenceurRevenue(user).commission }}% des
                                                revenus HT générés par vos affiliés vous seront reversés à vie.
                                                <br/>
                                                Nous avons mis à disposition un kit média avec des exemples de vidéos, de mail, des images de marque pour vous aider à promouvoir LyBox facilement :
                                                <a href="https://laced-mammal-6a4.notion.site/Ressources-affili-s-19ec6df1fe5280df85bfd14b905b5293">➡️ Accéder au kit média</a><br/>
                                                <br/>
                                                Voir les <a target="_blank" href="https://www.lybox.fr/affiliation">Conditions
                                                générales du programme d’affiliation</a>
                                            </div>

                                            <p class="text-center" *ngIf="filleuls != null && filleuls.length == 0">
                                                Aucun filleul
                                            </p>
                                            <ul class="filleuls"
                                                *ngIf="filleuls != null && !authenticationService.isInfluenceur(user)">
                                                <li *ngFor="let filleul of filleuls">
                                                    <button *ngIf="filleul.valid_filleul"
                                                            class="btn btn-sm btn-success">Validé
                                                    </button>
                                                    <button *ngIf="!filleul.valid_filleul"
                                                            class="btn btn-sm btn-outline">En attente
                                                    </button>
                                                    {{ filleul.firstname }} {{ filleul.lastname }}
                                                </li>
                                            </ul>
                                            <ul class="filleuls"
                                                *ngIf="filleuls != null && authenticationService.isInfluenceur(user)">
                                                <li *ngFor="let filleul of filleuls">
                                                    {{ filleul.created_at | date:'dd/MM/yyyy' }} :
                                                    <b *ngIf="filleul.valid_filleul"
                                                       [ngClass]="{'btn btn-sm': filleul.valid_filleul, 'btn-success': filleul.plan != '', 'btn-outline' : filleul.plan == ''}">
                                                        Forfait : {{ filleul.plan ? filleul.plan : 'résilié' }}
                                                    </b>
                                                    <b class="plan">
                                                        Total
                                                        : {{ (filleul.total / 100 / 100 / 1.2) * authenticationService.getInfluenceurRevenue(user).commission | number: '1.2-2' }}
                                                        €
                                                    </b>
                                                    {{ filleul.firstname }} {{ filleul.lastname[0] }}...
                                                </li>
                                            </ul>
                                            <h3 *ngIf="authenticationService.isInfluenceur(user)">Total des revenus
                                                d'affiliation : {{ totalComm | number: '1.2-2' }} €</h3>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card block isMinimizable minimize">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Historique de facturation</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row">
                                    <p class="text-center" *ngIf="invoices.length == 0">Aucune facture</p>
                                    <ul class="invoices">
                                        <li *ngFor="let invoice of invoices">
                                            <a class="pdf" *ngIf="invoice.invoice_pdf" (click)="openInvoice(invoice);">
                                                <i class="fa cfa cfa-pdf"></i>
                                            </a>
                                            <p class="date">
                                                {{ invoice.date }}
                                            </p>
                                            <p class="amount">
                                                {{ invoice.amount / 100 | number: '1.2-2' }} €
                                            </p>
                                        </li>
                                    </ul>
                                    <h3 class="mb-3" *ngIf="user.payment_method.type != ''">Moyen de paiement</h3>
                                    <div class="col-6">
                                        <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                                            Prélèvement bancaire<br/>
                                        </b>
                                        <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                                            {{ user.payment_method.type_detail | titlecase }} {{ user.payment_method.last_4 }}
                                            <br/>
                                            Expire en {{ user.payment_method.exp_month }}
                                            /{{ user.payment_method.exp_year }}
                                        </b>
                                    </div>
                                    <div class="col-6">
                                        <button (click)="updateCB()" class="btn btn-primary"
                                                *ngIf="user.payment_method.type != ''">
                                            Modifier mon moyen de paiement
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
